import script from "./review-index.vue?vue&type=script&setup=true&lang=js"
export * from "./review-index.vue?vue&type=script&setup=true&lang=js"

import "./review-index.vue?vue&type=style&index=0&id=af051682&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af051682"]])

export default __exports__